import type { FieldKeyValuePairs, Fields } from '../types'
import {
  findSupportedFieldTypes,
  getCandidateFields,
  findRightFieldKey,
} from '../utils'
import { DEFAULT_COLLECTION_FIELDS } from './predefinedCollection'
const { IMAGE, IMAGES_ALT_TEXT, LONG_DESCRIPTION, SHORT_DESCRIPTION, TITLE } =
  DEFAULT_COLLECTION_FIELDS

const getImageField = (fields: FieldKeyValuePairs) =>
  findRightFieldKey(fields, IMAGE)

const getImagesAltTextField = (fields: FieldKeyValuePairs) =>
  fields.some(([key]) => key === IMAGES_ALT_TEXT.fieldKey)
    ? IMAGES_ALT_TEXT.fieldKey
    : undefined

const getTitleField = (fields: FieldKeyValuePairs) =>
  findRightFieldKey(fields, TITLE, [
    SHORT_DESCRIPTION.fieldKey,
    LONG_DESCRIPTION.fieldKey,
  ])

const getShortDescriptionField = (fields: FieldKeyValuePairs) =>
  findRightFieldKey(fields, SHORT_DESCRIPTION, [LONG_DESCRIPTION.fieldKey])

const getLongDescriptionField = (fields: FieldKeyValuePairs) =>
  findRightFieldKey(fields, LONG_DESCRIPTION)

export const getFieldKeysForPreset = (fields: Fields) => {
  const supportedFieldTypes = findSupportedFieldTypes(DEFAULT_COLLECTION_FIELDS)

  const candidateFields = getCandidateFields({
    fields,
    supportedFieldTypes,
  })

  const imageFieldKey = getImageField(candidateFields)
  const imagesAltTextFieldKey = getImagesAltTextField(candidateFields)
  const titleFieldKey = getTitleField(candidateFields)

  const shortDescriptionFieldKey = getShortDescriptionField(
    candidateFields.filter(([key]) => key !== titleFieldKey),
  )

  const longDescriptionFieldKey = getLongDescriptionField(
    candidateFields.filter(
      ([key]) => ![titleFieldKey, shortDescriptionFieldKey].includes(key),
    ),
  )

  return {
    imageFieldKey,
    titleFieldKey,
    shortDescriptionFieldKey,
    longDescriptionFieldKey,
    imagesAltTextFieldKey,
  }
}
